import { Observable } from "rxjs";

export abstract class AbApp {

  abstract url: any
  abstract getAll(endPoint: string, filter?: string);
  abstract get(endPoint: string, id?: any, params?: any);
  abstract getBlob(endPoint: string);
  abstract save(endPoint: string, entity: any);
  abstract post(endPoint: string, entity: any): Observable<any>;
  abstract put(endPoint: string, id: number, entity: any): Observable<any>;
  abstract delete(endPoint: string, id: number);
  abstract deleteComBody(endPoint: string, body: any);
  abstract getResponseType(endPoint: string, responseType?: any);
  abstract getRelatorioS3(tipo: string): Observable<any>;
  abstract patch(endPoint: string, entity: any);
}